import linear_gauge from "devextreme/viz/linear_gauge";
import apiConfig from "../../../../config/api";

//const username = "PI_INT_CRMBP";
//const password = "NGcjNL6W4C.";

const getToken = () => localStorage.getItem("AccessToken");

const getRepresentanteLegal = async (rutEmpresa) => {
  try {
    // let res = await fetch(`${apiConfig.apiUriUCA}RESTAdapter/BuscaBPCRM`, {
    let res = await fetch(apiConfig.buscaBPCRM, {
      method: "POST",
      headers: {
        "Content-Type":"application/json",
        "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
        "Authorization": `Bearer ${getToken()}`,
        "company-rut": rutEmpresa
      },
      body: JSON.stringify({
        I_RUT: rutEmpresa,
      }),
    });

    res = await res.json();
    return res;
  } catch (error) {
    console.error("error: ", error);
    return error;
  }
};

const getRIM = async (data) => {
  try {
    //let res = await fetch(`https://ams-qa-midleware.azure-api.net/UCA/RESTAdapter/reajuste`, {
      let res = await fetch(`${apiConfig.apiUri}api/company/cotizaciones/reajuste`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
        //Authorization: `Basic ${btoa(`${username}:${password}`)}`,
        Authorization: `Bearer ${getToken()}`,
        "Ocp-Apim-Trace": true,
        "company-rut": data.IV_RUT
      },
      body: JSON.stringify(data),
    });

    res = await res.json();
    return res;
  } catch (error) {
    console.error("error: ", error);
    return error;
  }
};

const postDeclaration = async (data) => {
  let res = await fetch(`${apiConfig.apiUri}api/company/cotizaciones/declaracion`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
      "Ocp-Apim-Trace": true
    },
    body: JSON.stringify(data),
  });

  res = await res.json();
  return res;
}

export default {
  getRepresentanteLegal,
  getRIM,
  postDeclaration
};
